<template>
    <rest_select_list
        v-if="showRestSelectList"
        :key="'rest_stop_list'"
        :operationName="'stop_list'"
        :onlySelectLocations="true"
    />
</template>

<script>
import rest_select_list from "../RestSelectList.vue";
import products_select_stop_list from "./products/ProductsSelectStopList.vue";

import {createHelpers} from "vuex-map-fields";

const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})

export default {
    name: "rest_stop_list",
    components: {
        rest_select_list,
        products_select_stop_list
    },
    data() {
        return {
            isLoadedPos: false,
            isLoadedSelectLocationsId: false,
        }
    },
    beforeMount() {
        this.$store.dispatch('orders/POS_RESTAURANTS_LIST');
        this.$store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID');
        EventBus.$on('load_pos_restaurants_list', this.loadPosRestaurantsList);
        EventBus.$on('get_all_active_locations_id', this.getAllActiveLocationsId);
    },
    beforeUnmount() {
        EventBus.$off('load_pos_restaurants_list', this.loadPosRestaurantsList);
        EventBus.$off('get_all_active_locations_id', this.getAllActiveLocationsId);
    },
    methods: {
        loadPosRestaurantsList() {
            this.isLoadedPos = true;
        },
        getAllActiveLocationsId() {
            this.isLoadedSelectLocationsId = true;
        },
    },
    computed: {
        ...mStopList([
            'activeItemStopListGroups',
        ]),
        isLoaded() {
            return this.isLoadedPos && this.isLoadedSelectLocationsId;
        },
        showRestSelectList() {
            if (this.isLoaded && this.activeItemStopListGroups.id === 1) {
                return true;
            }
            return false;
        },
    }
}
</script>
